(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[185],{

/***/ "2Ufl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTitle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var LineTitle = function LineTitle(_ref) {
  var className = _ref.className,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className"]);

  return __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mb-20', className),
    theme: "title-brand-n1"
  }));
};

/***/ }),

/***/ "WtX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("DfhM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("tVqn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/frameworks/image/constants.js
var constants = __webpack_require__("znkg");

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/track-click/TrackClick.jsx
var TrackClick = __webpack_require__("NJJ8");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx + 1 modules
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// CONCATENATED MODULE: ./src/client/components/lines/brand-promise-line/BrandPromiseLine.jsx





var __jsx = react_default.a.createElement;















var STYLES = {
  IMAGE: {
    height: '235px',
    width: '180px'
  }
};
var IMAGE_SIZE = {
  h: 235,
  w: 180
};
var RATIO_DISPLAYS = [{
  value: 1 / 6,
  unit: constants["d" /* DISPLAY_REM */]
}, {
  value: 180,
  unit: 'px'
}, {
  value: 180,
  unit: 'px'
}, {
  value: 180,
  unit: 'px'
}];

var BrandPromiseLine_Item = function Item(_ref) {
  var showPicture = _ref.showPicture,
      text = _ref.text,
      iconName = _ref.iconName,
      isExclusiveCollection = _ref.isExclusiveCollection,
      mediaUrl = _ref.mediaUrl,
      mediaAlt = _ref.mediaAlt,
      link = _ref.link,
      index = _ref.index;
  var TagName = link ? TrackClick["a" /* TrackClick */] : react["Fragment"];
  var pageContext = Object(PageContext["b" /* usePageContext */])();
  var siteSection = (pageContext === null || pageContext === void 0 ? void 0 : pageContext.siteSection) || '';
  var trackingData = {
    actionGA: 'push_content_brandPromise',
    labelGA: "".concat(iconName !== null && iconName !== void 0 ? iconName : '').trim(),
    thumbnailList: "".concat(siteSection, "_brandPromise"),
    thumbnailPosition: index + 1
  };
  var conditionalTagNameProps = link ? {
    as: DynamicLink["a" /* default */],
    url: link,
    trackingData: trackingData
  } : {};
  var badgeProps = {
    containerClassName: 'rounded-full',
    iconContainerWidth: '84',
    iconContainerHeight: '84',
    iconClassName: '',
    iconWidth: isExclusiveCollection ? 'calc(55rem / 16)' : 'calc(31rem / 16)',
    isNotSquare: false
  };
  return __jsx("div", {
    key: text,
    className: classnames_default()('group isolate relative'),
    "data-testid": "BrandPromiseLine-item"
  }, showPicture && __jsx("div", {
    className: "flex isolate items-end justify-center overflow-hidden p-10 shrink-0 text-center relative rounded-12",
    style: STYLES.IMAGE
  }, __jsx(Image["a" /* Image */], {
    altMsg: mediaAlt,
    className: "absolute inset-0 transition-transform duration-250 ease-in transform group-hover:scale-105 group-focus:scale-105",
    dimensions: IMAGE_SIZE,
    imageUrl: mediaUrl,
    ratioDisplay: RATIO_DISPLAYS
  })), __jsx(TagName, conditionalTagNameProps, showPicture && __jsx("div", {
    className: "relative",
    style: {
      height: '235px',
      marginTop: '-235px'
    }
  }), __jsx("div", {
    style: {
      width: '180px'
    },
    className: "text-black"
  }, __jsx("div", {
    className: "m-auto overflow-hidden relative",
    style: {
      height: '72px',
      marginTop: showPicture ? '-42px' : null,
      width: '126px'
    }
  }, __jsx("div", {
    className: classnames_default()('bg-white m-auto flex items-center justify-center', badgeProps.containerClassName),
    style: {
      width: "calc(".concat(badgeProps.iconContainerWidth, "rem / 16)"),
      height: "calc(".concat(badgeProps.iconContainerHeight, "rem / 16)")
    }
  }, __jsx(Icon["a" /* Icon */], {
    className: badgeProps.iconClassName,
    color: colors["a" /* COLORS */].SIENNA,
    isNotSquare: badgeProps.isNotSquare,
    name: iconName,
    width: badgeProps.iconWidth
  }))), __jsx(Text["a" /* Text */], {
    className: "text-14 text-center",
    color: "current",
    text: text
  }))));
};

var BrandPromiseLine_BrandPromiseLine = function BrandPromiseLine(_ref2) {
  var id = _ref2.id,
      title = _ref2.title,
      items = _ref2.items,
      learnMoreLink = _ref2.learnMoreLink,
      learnMoreLabel = _ref2.learnMoreLabel;

  // use isDesktop to display slider's controls only on desktops
  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet,
      isDesktop = _useResponsive.isDesktop;

  var trackingData = {
    actionGA: 'push_content_brandPromise',
    labelGA: 'seeMore'
  };
  var showPicture = items.every(function (item) {
    return !!item.mediaUrl;
  });
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    id: id
  }, __jsx("div", {
    className: "flex flex-wrap justify-between"
  }, !!title && __jsx(LineTitle["a" /* LineTitle */], {
    className: "flex-1 md:flex-none"
  }, title), learnMoreLabel && learnMoreLink && __jsx(TrackClick["a" /* TrackClick */], {
    as: DynamicLink["a" /* default */],
    className: "m-auto md:mx-0 mt-15 md:mt-5 order-last md:order-0 text-14 text-black hocus:text-black-active underline",
    trackingData: trackingData,
    url: learnMoreLink
  }, learnMoreLabel), __jsx("div", {
    className: "-mx-20 lg:mx-0 w-screen lg:w-full"
  }, __jsx(Slider["a" /* Slider */], {
    cols: 0,
    hasControls: isDesktop,
    navPosition: "center",
    nbItemsToScroll: isTablet ? 2 : 1,
    nextLabel: Object(i18n["h" /* t */])('common.next'),
    previousLabel: Object(i18n["h" /* t */])('common.previous'),
    scrollAreaContainerClassName: "gap-20 px-20 lg:px-0 scroll-x-area",
    scrollControlsClassName: "-mx-20 lg:mx-0"
  }, items.map(function (item, index) {
    return __jsx(BrandPromiseLine_Item, Object(esm_extends["a" /* default */])({}, item, {
      index: index,
      key: item.text,
      showPicture: showPicture
    }));
  })))));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/brand-promise/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (BrandPromiseLine_BrandPromiseLine);

/***/ })

}]);